import 'react-app-polyfill/ie11';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';
import './index.css';

// Import components
import { Menu, Work, Works, Contact, Statement, CV, NotFound } from './components';

// Site component - main app wrapper
class Site extends React.Component {
  render() {
    return (
      <Router>
        <>
          <div className="container">
            <Menu />
            <Routes>
              <Route path="/" element={<Works />} />
              <Route path="/beta" element={<Works />} />
              <Route path="/work" element={<Works />} />
              <Route path="/work/:workid" element={<Work />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/statement" element={<Statement />} />
              <Route path="/cv" element={<CV />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <img src="/footer.png" alt="Footer" className="footer"></img>
        </>
      </Router>
    );
  }
}

// ========================================

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<Site />);
}